import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { Ge as z, hi as N, bo as d, w as k, M as b, fi as S, di as x } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as T } from "./state-b4c9cc73-ee633f6c.js";
import { e as E } from "./map-7910a3a7-389c4b7b.js";
import { v as I, z as R, n as a, Q as $ } from "./overlay-primitive-6d952482-a90fe5be.js";
import { L as h } from "./chart-tooltip-e4995844-42c7681e.js";
import { o as u } from "./chart-tooltip.constants-f76f46e6-1f185240.js";
import { r as v } from "./tooltip-arrows-fd80a6d9-de935ade.js";
import "./utils-2e24a437-383bbd0f.js";
import "./query-24926cff-3eb94bfb.js";
import "./keys-b2183e45-74d07070.js";
import "./orientations-42163445-a7edd586.js";
import "./lifecycle-decorators-ecc4e836-92da4b80.js";
import "./query-assigned-ba663908-228b08f4.js";
function B(p) {
  switch (p) {
    case a.BlockStart:
      return v.UP;
    case a.InlineEnd:
      return v.RIGHT;
    case a.InlineStart:
      return v.LEFT;
    case a.BlockEnd:
    default:
      return v.DOWN;
  }
}
var C = z(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name=beacon-chart-tooltip][variant=multi-level] [beacon-tag-name=beacon-chart-tooltip-data]:not([subset]){--beacon-chart-tooltip-override-divider-border-block-end: var(--beacon-border-width-small) solid var(--beacon-chart-tooltip-divider-color-background);--beacon-chart-tooltip-override-container-main-padding-block-end: var(--beacon-unit-atomic)}[beacon-tag-name=beacon-chart-tooltip][variant=multi-level] [beacon-tag-name=beacon-chart-tooltip-data]:not([subset])+[beacon-tag-name=beacon-chart-tooltip-data][subset]{--beacon-chart-tooltip-override-container-subset-margin-block-start: var(--beacon-unit-atomic);margin-block-start:0}[beacon-tag-name=beacon-chart-tooltip][variant^=multi]>*:not(style)+*:not(style){margin-block-start:var(--beacon-unit-subatomic)}\n"]))),
  O = z(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{inline-size:fit-content;inset-block-start:0;inset-inline-start:0;max-inline-size:var(--beacon-custom-chart-tooltip-size-max-inline-size, none)}.tooltip-content{align-items:center;background-color:var(--beacon-chart-tooltip-color-background);border-radius:var(--beacon-unit-subatomic);box-shadow:var(--beacon-elevation-block-end-level-1);display:grid;min-block-size:var(--beacon-chart-tooltip-size-block-size);padding:var(--tooltip-padding)}.overlay-wrapper{inset-block-start:var(--top-offset);inset-inline-start:var(--left-offset);position:absolute}:host([variant=single-line]){--tooltip-padding: var(--beacon-chart-tooltip-space-padding-default)}:host([variant=single-line]) .overlay-wrapper{--arrow-margin: var(--beacon-unit-atomic);--arrow-block-size: calc(.375 * var(--beacon-unit-base));--arrow-inline-size: calc(.75 * var(--beacon-unit-base));display:flex;flex-direction:var(--flex-direction, column)}:host([variant=single-line]) .overlay-wrapper.block-end{--flex-direction: column-reverse}:host([variant=single-line]) .overlay-wrapper:is(.inline-end,.inline-start){--arrow-alignment-override: center;--arrow-block-size: calc(.75 * var(--beacon-unit-base));--arrow-inline-size: calc(.375 * var(--beacon-unit-base));--arrow-margin: 0}:host([variant=single-line]) .overlay-wrapper.inline-start{--flex-direction: row}:host([variant=single-line]) .overlay-wrapper.inline-end{--flex-direction: row-reverse}:host([variant=single-line]) .arrow-container{align-self:var(--arrow-alignment-override, var(--arrow-alignment, center));display:flex;inline-size:fit-content}:host([variant=single-line]) .arrow-container.start{--arrow-alignment: start;margin-inline-start:var(--arrow-margin)}:host([variant=single-line]) .arrow-container.center{margin:0}:host([variant=single-line]) .arrow-container.end{--arrow-alignment: end;margin-inline-end:var(--arrow-margin)}:host([variant=single-line]) .arrow-container .tooltip-arrow{block-size:var(--arrow-block-size);fill:var(--beacon-chart-tooltip-color-background);inline-size:var(--arrow-inline-size)}:host([variant=single-line]) ::slotted([beacon-tag-name=beacon-chart-tooltip-data]){padding-inline:var(--beacon-unit-subatomic)}:host([variant^=multi-]){--beacon-chart-tooltip-override-label-padding-block-start: var(--beacon-unit-subatomic);--beacon-chart-tooltip-override-metric-padding-block-start: var(--beacon-unit-subatomic);--tooltip-padding: calc(var(--beacon-chart-tooltip-space-padding-list) + var(--beacon-chart-tooltip-space-padding-default))}.title{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));margin-block-end:var(--beacon-unit-subatomic)}\n"])));
var A = Object.defineProperty,
  L = Object.getOwnPropertyDescriptor,
  l = function l(p, t, e, o) {
    for (var i = o > 1 ? void 0 : o ? L(t, e) : t, r = p.length - 1, s; r >= 0; r--) (s = p[r]) && (i = (o ? s(t, e, i) : s(i)) || i);
    return o && i && A(t, e, i), i;
  };
var n = /*#__PURE__*/function (_N) {
  _inherits(n, _N);
  function n() {
    var _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.beaconTagName = u.beaconTagName, _this.variant = h.SINGLE_LINE, _this.tooltipTitle = "", _this.disableTitle = !1, _this.overrideColor = "", _this.disableArrow = !1, _this.tooltipData = [], _this.trigger = I.MANUAL;
    return _this;
  }
  _createClass(n, [{
    key: "computeDirection",
    /**
     * Determines what direction the tooltip should point
     */
    value: function computeDirection() {
      this.variant === h.SINGLE_LINE && (this.direction = this.orientation === R.VERTICAL ? a.BlockEnd : a.InlineStart);
    }
    /**
     * Calculates the positioning of the tooltip
     */
  }, {
    key: "calculateOffset",
    value: function calculateOffset() {
      var t, e;
      if (this.getBoundingClientRect() && (t = this.getBoundingClientRect()), this.getRootNode() && this.getRootNode().host && this.getRootNode().host.getBoundingClientRect() && (e = this.getRootNode().host.getBoundingClientRect()), this.targetRectObj) {
        var o = this.targetRectObj;
        if (this.computeDirection(), this.direction === a.BlockEnd) {
          var _this$transformAnchor = this.transformAnchorPoint((o.left - t.left + (o.right - t.right)) / 2, o.top - e.top),
            i = _this$transformAnchor.x,
            r = _this$transformAnchor.y;
          this.leftOffset = i, this.topOffset = r - 4 + window.scrollY;
        } else if (this.direction === a.InlineStart) {
          var _this$transformAnchor2 = this.transformAnchorPoint(o.right - t.right, (o.top - e.top + (o.bottom - e.top)) / 2),
            _i = _this$transformAnchor2.x,
            _r = _this$transformAnchor2.y;
          this.leftOffset = _i + 4, this.topOffset = _r + window.scrollY;
        }
      }
    }
    /**
     * Transforms the anchor point from the top left corner to the arrow point
     */
  }, {
    key: "transformAnchorPoint",
    value: function transformAnchorPoint(t, e) {
      var o, i;
      var r = 0,
        s = 0;
      var f = (o = this.shadowRoot) == null ? void 0 : o.querySelector(".arrow-container"),
        w = (i = this.shadowRoot) == null ? void 0 : i.querySelector(this.overlaySelector);
      if (f && w) {
        var c = f.getBoundingClientRect(),
          y = w.getBoundingClientRect();
        var g = 0,
          m = 0;
        this.direction === a.BlockEnd ? (g = (c.left + c.right) / 2, m = c.bottom) : this.direction === a.InlineStart && (g = c.left, m = (c.top + c.bottom) / 2), r = g - y.x, s = m - y.y;
      }
      return {
        x: t - r,
        y: e - s
      };
    }
    /**
     * Custom postrender hook handler
     */
  }, {
    key: "renderTitle",
    /**
     * @returns template to render title
     */
    value: function renderTitle() {
      return this.variant !== h.SINGLE_LINE && !this.disableTitle && this.tooltipTitle ? d(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"title\">", "</div>"])), this.tooltipTitle) : k;
    }
    /**
     * @returns template to render tooltip arrow
     */
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      return this.variant === h.SINGLE_LINE ? d(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div class=\"arrow-container ", "\">", "</div>"])), this.alignment, this.disableArrow ? k : B(this.direction)) : d(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
    }
    /**
     * @returns template to render chart-tooltip-data
     */
  }, {
    key: "renderSlot",
    value: function renderSlot() {
      var _this2 = this;
      var t;
      return (t = this.tooltipData) != null && t.length ? d(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), E(this.tooltipData, function (e) {
        return x(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<", " label=\"", "\" value=\"", "\" index=\"", "\" color=\"", "\">\n        </", ">"])), _this2.getScopedTag("beacon-chart-tooltip-data"), e.label, e.value, e.index, _this2.overrideColor, _this2.getScopedTag("beacon-chart-tooltip-data"));
      })) : d(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<slot></slot>"])));
    }
    /**
     * @returns template to override overlay content
     */
  }, {
    key: "renderOverlayContent",
    value: function renderOverlayContent() {
      return d(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", "", ""])), this.renderTitle(), this.renderSlot());
    }
  }, {
    key: "postrenderHooks",
    get: function get() {
      return [this.overlayPostrender];
    }
  }], [{
    key: "styles",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(n), "styles", this)), [O]);
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(n), "lightDOMStyles", this), C];
    }
  }]);
  return n;
}(N(S, $()));
n.tagName = u.beaconTagName;
n.nestedComponents = u.beaconNestedComponents;
l([b({
  reflect: !0
})], n.prototype, "variant", 2);
l([b({
  attribute: "tooltip-title"
})], n.prototype, "tooltipTitle", 2);
l([b({
  attribute: "disable-title",
  type: Boolean
})], n.prototype, "disableTitle", 2);
l([b({
  attribute: "override-color",
  type: String
})], n.prototype, "overrideColor", 2);
l([b({
  attribute: "disable-arrow",
  type: Boolean
})], n.prototype, "disableArrow", 2);
l([b({
  attribute: !1,
  type: Array
})], n.prototype, "tooltipData", 2);
l([T()], n.prototype, "trigger", 2);
export { n as BeaconChartTooltip };